import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';

/**
 * Frontend registry entry for the runner-internal `Suppressed` step kind.
 *
 * Users never author a Suppressed step. The routine→runner converter
 * (`convertRoutineToRoutineRunnerSchema`) emits it in place of any suppressed
 * step so the runner receives the full step tree without converting the
 * suppressed step's real (possibly unconfigured) configuration. This entry
 * exists only to satisfy the exhaustive `STEP_KIND_INFO` `Record<StepKind>`; it
 * is `Hidden` from the step library and its `toRoutineRunner` is never invoked
 * from the frontend authoring path.
 */
export namespace SuppressedStep {
  export const name = 'Suppressed';
  export const description = 'A step suppressed in the routine editor';
  export const isDecorator = true;
  export const librarySection = Step.LibrarySection.Hidden;
  export const argumentKind = 'Suppressed';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({ stepData }) => ({
    ...stepData,
    stepKind: 'Suppressed',
    args: {},
  });
}

SuppressedStep satisfies Step.StepKindInfo;
